import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * for this page
 */
import { Survey, WxLaunchHack } from 'ThreeTerminal_mobile_dynamic';

import WeMediaInfo from './weMediaInfo';
import Summary from './summary';
import CommentBox from './commentBox';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        id: PropTypes.string,
        isCallClientLiveVideo: PropTypes.bool,
        liveId: PropTypes.string,
    };

    state = {
        surveyData: this.props.content.surveyData,
    };

    render() {
        const { content, id, isCallClientLiveVideo, liveId } = this.props;
        const { fhhAccountDetail, base62Id } = content;
        const { surveyData } = this.state;

        // console.log(surveyData);
        // console.log(id);

        const callAppConfig = {
            docType: 'survey',
            pid: base62Id,
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7174415196693892096',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9195',
            kind: 'inter_mdfcld0201',
            noKindFrom: 1,
        };
        const clickCount = {
            clickBar: {
                behavior: 'action',
                type: 'survey_pop',
                other: {
                    id: `ucms_${base62Id}`,
                    surveyid: `survey_${base62Id}`,
                    url: encodeURIComponent(location.href),
                },
            },
            clickCallApp: {
                behavior: 'action',
                type: 'survey_pop_app',
                other: {
                    id: `ucms_${base62Id}`,
                    surveyid: `survey_${base62Id}`,
                    url: encodeURIComponent(location.href),
                },
            },
            clickSubmit: {
                behavior: 'action',
                type: 'subquest',
                other: {
                    id: `ucms_${base62Id}`,
                    surveyid: `survey_${base62Id}`,
                },
            },
        };

        const wxLaunchHackData1 = {
            callAppConfig: {
                docType: 'web',
                pid: `https://flive.ifeng.com/live/${liveId}.html?isFull=1&webkit=1&immersion=true&needpage=1`,
                kind: 'inter_splh02',
                noKindFrom: 1,
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7248753076782225408',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9152',
            },
            statisticsConfig: {
                behavior: 'action',
                type: 'livesurvey02',
            },
        };

        const wxLaunchHackData2 = {
            callAppConfig: {
                docType: 'web',
                pid: `https://flive.ifeng.com/live/${liveId}.html?isFull=1&webkit=1&immersion=true&needpage=1`,
                kind: 'inter_splh01',
                noKindFrom: 1,
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7248752896393597952',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9151',
            },
            statisticsConfig: {
                behavior: 'action',
                type: 'livesurvey01',
            },
        };

        return id ? (
            <div>
                <div className={styles.content}>
                    <div className={styles.callClientLiveBox}>
                        {fhhAccountDetail && <WeMediaInfo content={{ fhhAccountDetail, base62Id }} />}
                        <Summary content={surveyData.surveyinfo} />
                        {isCallClientLiveVideo && (
                            <div className={styles.callClientLive}>
                                <WxLaunchHack content={wxLaunchHackData1} />
                            </div>
                        )}
                    </div>
                    <div className={styles.callClientLiveBox}>
                        <Survey surveyId={id} callAppConfig={callAppConfig} clickCount={clickCount} isShowBar={false} isShowLogo={false} />
                        {isCallClientLiveVideo && (
                            <div className={styles.callClientLive}>
                                <WxLaunchHack content={wxLaunchHackData2} />
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.blank} />
                {surveyData.surveysetting && Number(surveyData.surveysetting.iscomment) ? (
                    <div className={styles.callClientLiveBox}>
                        <CommentBox content={surveyData.surveyinfo} base62Id={base62Id} />
                        {isCallClientLiveVideo && (
                            <div className={styles.callClientLive}>
                                <WxLaunchHack content={wxLaunchHackData1} />
                            </div>
                        )}
                    </div>
                ) : null}
            </div>
        ) : null;
    }
}

export default Content;
